module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAADCAMAAAAwYnbuAAAAkFBMVEUAAABXVEn//vv6+fb08+/t7Ojd29bT0c20sqypp6CenJWUkYrmxoDiw37dvnzXunnQtHeAfHXIrnTBqHF2dGuvmWqdi2NtamGUhF+BdVl5blVeW1JxaFFpYk9iXExcWEnl4+DJxsK+vLeKh4C4oG2mkmeKfFtlYlnk5N/Jx8K/vbeKh3+4oW6lkmeLfVxlY1nNcQpuAAAAAXRSTlMAQObYZgAAAE1JREFUCNdj4OHl4xcQElYRVRWTUJOUkpGVk2dkAAEmZhZWBTZ2RS0OTi5uZUERcXVpRhTVelhUayrBVOsjVOuI6mIxWwNoNli1NsRsAIwQCWidDcvSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/line.png
// module id = 887
// module chunks = 1